import React, { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import "./popupModal.scss";
import {
  Button,
  Grid,
  Box,
  Paper,
  TextField,
  IconButton,
  InputAdornment,
  OutlinedInput,
  MenuItem,
  Select,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  submitEsignBatch,
  validateUserClear,
} from "../../../redux/validation/actions";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";
import CloseIcon from "@mui/icons-material/Close";
import { messages } from "../../../constants/commonMessages";
import { notification } from "../../../constants/notificationMessages";

export default function BasicModal({
  openAuth,
  handleClose,
  handleUserPermission,
}) {
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [remark, setRemark] = useState("");
  const [passwordType, setPasswordType] = useState(false);
  const dispatch = useDispatch();
  const validateUsers = useSelector((state) => state?.validation?.validateUser);
  const [errorMessage, setErrorMessage] = useState("");
  const [operationValue, setOperationValue] = useState("");
  const operations = {
    comment_format: "Comment Format",
    // supermix: "Supermix",
    // premix_a: "Premix A",
    // iam_manufacturing: "IAM Manufacturing",
    // cell_Free_protein_synthesis: "Cell-Free Protein Synthesis",
    // depth_filtration: "Depth Filtration",
    // bioburden_reduction_filtration_and_transfer_to_dsp:
    //   "Bioburden Reduction Filtration and Transfer to DSP",
    none: "None",
  };
  const isValidator = localStorage.getItem("userRole") === "investigatorValidatior";
  const handleChange = (event) => {
    setOperationValue(event.target.value);
  };

  useEffect(() => {
    dispatch(validateUserClear());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleUsernameChange = (name) => {
    setErrorMessage("");
    setUserName(name);
  };
  const handlePasswordChange = (name) => {
    setPassword(name);
    setErrorMessage("");
  };

  let validateUser;
  useEffect(() => {
    if (localStorage.getItem("userRole") === "investigator") {
      setRemark(notification.remarkInvestigator);
    }
    validateUser = validateUsers;
    if (
      validateUser?.loader === false &&
      validateUser?.next === true &&
      validateUser?.message === ""
    ) {
      handleClose();
      handleUserPermission(operationValue);
      dispatch(validateUserClear());
    }
    if (validateUser?.message !== "") {
      setErrorMessage(validateUser?.message);
    }
  }, [validateUsers, remark]);
  const handelAuthSubmit = () => {
    dispatch(
      submitEsignBatch(
        userName,
        localStorage.userid,
        localStorage.userRole,
        password
      )
    );
  };

  const togglePassword = () => {
    setPasswordType(!passwordType);
  };
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <div>
      {/* {"openAuth"} */}
      <Modal
        open={openAuth}
        onClose={handleClose}
        aria-describedby="modal-modal-description"
      >
        <Box component={Paper} className="modal-box">
          <Grid container className="modal-popup">
            <Grid item>
              <div className="modal-title">
                <h4>
                  {messages.AUTH_CREDS}
                  <span className="close-btn">
                    <CloseIcon onClick={handleClose} />
                  </span>
                </h4>
                <p className="modal-subtext">{messages.AUTH_P}</p>
              </div>
              <div className="input-wrap">
                <label>{messages.USER_NAME_AUTH}</label>
                <OutlinedInput
                  size="medium"
                  fullWidth
                  placeholder="User Name"
                  onChange={(e) => handleUsernameChange(e.target.value)}
                />
              </div>
              <div className="input-wrap">
                <label>{messages.PASS}</label>
                <OutlinedInput
                  fullWidth={true}
                  size="medium"
                  type={passwordType ? "text" : "password"}
                  required
                  onChange={(e) => handlePasswordChange(e.target.value)}
                  name="password"
                  placeholder="Password"
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={togglePassword}
                        onMouseDown={handleMouseDownPassword}
                      >
                        {passwordType ? <Visibility /> : <VisibilityOffIcon />}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </div>
              <div className="input-wrap">
                <label>Remark</label>
                <TextField fullWidth value={remark} disabled></TextField>
              </div>
              {isValidator && (
                <div className="input-wrap">
                  <label>Select Post-processing Script</label>
                  <Select
                    fullWidth
                    labelId="operation-select-label"
                    value={operationValue}
                    onChange={handleChange}
                    // label="Select Operation"
                  >
                    {Object.entries(operations).map(([key, label]) => (
                      <MenuItem key={key} value={key}>
                        {label}
                      </MenuItem>
                    ))}
                  </Select>
                </div>
              )}

              <div className="error">
                {errorMessage && <label>{errorMessage}</label>}
              </div>
              <Button
                className="button-submit"
                onClick={handelAuthSubmit}
                disabled={
                  isValidator
                    ? userName === "" ||
                      password === "" ||
                      operationValue === ""
                    : userName === "" || password === ""
                }
              >
                Continue
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
}
